import { FC } from 'react';
import { AllieCardStyled, AllieTextStyled, QueryItemContainer } from './QueryItem.styles';
import { AllieArrowForwardOutlineIcon } from '../../../../../styling/icons';

interface QueryItemActionProps {
  onClick: (id: number) => void;
}

export interface QueryItemDataProps {
  text: string;
  id: number;
  lineClamp?: number;
}

export interface QueryItemProps extends QueryItemDataProps, QueryItemActionProps {}

export const QueryItem: FC<QueryItemProps> = ({ text, id, lineClamp, onClick }) => {
  return (
    <AllieCardStyled
      radius="xl"
      content={{
        children: (
          <QueryItemContainer>
            <AllieTextStyled
              type="body1"
              color="neutral-70"
              lineClamp={lineClamp}
            >
              {text}
            </AllieTextStyled>
            <AllieArrowForwardOutlineIcon style={{ fontSize: 24, flexShrink: 0 }} />
          </QueryItemContainer>
        ),
      }}
      onClick={() => onClick(id)}
    />
  );
};
